(ns dashboard.events.users
  (:require
   [re-frame.core :as re-frame]
   [graphql-query.core :refer [graphql-query]]
   [dashboard.db :as db :refer [local-store->]]
   [dashboard.utils :refer [graphql-request-format index-of]]
   [dashboard.interceptors :refer [standard-interceptors ->local-store]]
   [dashboard.config :as config]
   [ajax.core :as ajax]))

(def user-fields
  [:id :organizationId :auth0UserId :firstName :lastName :firstNameJp
   :lastNameJp :titleId :email :phoneNumber :roleId :spokenLanguages :locale
   :spaceId :externalId :created])

;; Get User profile

(defn get-user-query
  [{:keys [id]}]
  {:operation {:operation/type :query
               :operation/name :getUser}
   :queries [[:getUser
              {:id id}
              user-fields]]})

(re-frame/reg-event-fx
 ::get-user
 standard-interceptors
 (fn [{:keys [db]} [id]]
   {:graphql-request {:query (graphql-query (get-user-query {:id id}))
                      :on-success [::get-user-success]}}))

(re-frame/reg-event-fx
 ::get-user-success
 standard-interceptors
 (fn [{:keys [db]} [res]]
   (js/console.log res)))

(defn get-user-by-auth0-query
  [{:keys [id]}]
  {:operation {:operation/type :query
               :operation/name :getUserByAuth0UserId}
   :queries [[:getUserByAuth0UserId
              {:auth0UserId id}
              user-fields]]})

(re-frame/reg-event-fx
 ::get-userinfo
 standard-interceptors
 (fn [{:keys [db]} []]
   (let [auth0-id (get (:auth0/user-data db) "sub")]
     {:graphql-request {:query (graphql-query (get-user-by-auth0-query {:id auth0-id}))
                        :on-success [::get-userinfo-success]}})))

(re-frame/reg-event-db
 ::get-userinfo-success
 [(re-frame/path :settings)
  standard-interceptors]
 (fn [settings [result]]
   (if (some? result)
     (-> settings
         (assoc :userinfo (:getUserByAuth0UserId (:data result))))
     settings)))

(re-frame/reg-event-fx
 ::get-userinfo-fail
 standard-interceptors
 (fn [{:keys [db]} [res]]
   (js/console.log res)))

;; Create

(defn create-user-query
  [{:keys [user]}]
  {:operation {:operation/type :mutation
               :operation/name :addUser}
   :queries [[:addUser
              user
              user-fields]]})

(re-frame/reg-event-fx
 ::create-user
 standard-interceptors
 (fn [{:keys [db]} [{:keys [user]}]]
   {:graphql-request {:query (graphql-query (create-user-query {:user user}))
                      :on-success [::create-user-success]}}))

(re-frame/reg-event-fx
 ::create-user-success
 standard-interceptors
 (fn [{:keys [db]} [res]]
   (if (some? (:errors res))
     {:show-notification!
      {:title "Error"
       :intent :intent/danger
       :message (clojure.string/join "\n" (map :message (:errors res)))}
      :db db}
     {:show-notification!
      {:title "User Created"
       :intent :intent/success
       :duration 10000
       :message (str "You successfuly created "
                     (:firstName (get-in res [:data :addUser])) " "
                     (:lastName (get-in res [:data :addUser])))}
      :dispatch [::add-user (get-in res [:data :addUser])]})))

(re-frame/reg-event-fx
 ::create-userinfo
 standard-interceptors
 (fn [{:keys [db]} [{:keys [user]}]]
   {:graphql-request {:query (graphql-query (create-user-query {:user user}))
                      :on-success [::create-userinfo-success]}}))

(re-frame/reg-event-db
 ::create-userinfo-success
 [(re-frame/path :settings)
  standard-interceptors]
 (fn [settings [result]]
   (if (some? result)
     (-> settings
         (assoc :userinfo (:addUser (:data result))))
     settings)))

;; Update User

(defn update-user-query-
  [{:keys [user]}]
  {:operation {:operation/type :mutation
               :operation/name :updateUser}
   :variables [{:variable/name :$id
                :variable/type :ID!
                :variable/default (:id user)}
               {:variable/name :$externalId
                :variable/type :String
                :variable/default (str (:externalId user))}
               {:variable/name :$firstName
                :variable/type :String
                :variable/default (or (:firstName user) "")}
               {:variable/name :$lastName
                :variable/type :String
                :variable/default (or (:lastName user) "")}
               {:variable/name :$firstNameJp
                :variable/type :String
                :variable/default (or (:firstNameJp user) "")}
               {:variable/name :$lastNameJp
                :variable/type :String
                :variable/default (or (:lastNameJp user) "")}
               {:variable/name :$titleId
                :variable/type :ID
                :variable/default (or (:titleId user) "")}
               {:variable/name :$spaceId
                :variable/type :ID
                :variable/default (or (:spaceId user) "")}
               {:variable/name :$spokenLanguages
                :variable/type (keyword "[Language]")
                :variable/default (mapv keyword (into [] (:spokenLanguages user)))}]
   :queries [[:updateUser
              {:id :$id
               :externalId :$externalId
               :firstName :$firstName
               :lastName :$lastName
               :firstNameJp :$firstNameJp
               :lastNameJp :$lastNameJp
               :titleId :$titleId
               :spaceId :$spaceId
               :spokenLanguages :$spokenLanguages}
              user-fields]]})

(defn update-user-query
  [{:keys [user]}]
  {:operation {:operation/type :mutation
               :operation/name :updateUser}
   :queries [[:updateUser
              (->  user
                   (assoc :spokenLanguages (into [] (map keyword (:spokenLanguages user))))
                   (assoc :locale (keyword (:locale user)))
                   (dissoc :organizationId :auth0UserId :created))
              user-fields]]})

(re-frame/reg-event-fx
 ::update-user
 standard-interceptors
 (fn [{:keys [db]} [{:keys [user]}]]
   {:graphql-request {:query (graphql-query (update-user-query {:user user}))

                      :on-success [::update-user-success]}}))

(re-frame/reg-event-fx
 ::update-user-success
 standard-interceptors
 (fn [{:keys [db]} [res]]
   (if (some? (:errors res))
     {:show-notification!
      {:title "Error Updating User"
       :intent :intent/danger
       :duration 10000
       :message (clojure.string/join "\n" (map :message (:errors res)))}
      :db db}
     {:show-notification!
      {:title "User Updated"
       :intent :intent/success
       :duration 10000
       :message (str "You successfuly updated "
                     (:firstName (get-in res [:data :updateUser])) " "
                     (:lastName (get-in res [:data :updateUser])))}
      :dispatch [::edit-user (get-in res [:data :updateUser])]})))

;; List Users

(defn list-users-by-organization-query
  [{:keys [organization-id]}]
  {:operation {:operation/type :query
               :operation/name :allUsersByOrganization}
   :queries [[:allUsersByOrganization
              {:organizationId organization-id}
              {:users user-fields}]]})

(re-frame/reg-event-fx
 ::list-users-by-organization
 standard-interceptors
 (fn [{:keys [db]} [{:keys [organization-id]}]]
   (let [organization-id (or organization-id
                             (get-in db [:settings :organization :id]))]
     {:graphql-request {:query (graphql-query (list-users-by-organization-query
                                                  {:organization-id organization-id}))
                        :on-success [::list-users-by-organization-success]}})))

(re-frame/reg-event-fx
 ::list-users-by-organization-success
 standard-interceptors
 (fn [{:keys [db]} [res]]
   {:db (assoc db :staffs (get-in res [:data :allUsersByOrganization :users]))}))

;; Delete User

(defn delete-user-query
  [{:keys [user]}]
  {:operation {:operation/type :mutation
               :operation/name :deleteUser}
   :queries [[:deleteUser
              {:id (:id user)}
              user-fields]]})

(re-frame/reg-event-fx
 ::delete-user
 standard-interceptors
 (fn [{:keys [db]} [{:keys [user]}]]
   {:graphql-request {:query (graphql-query (delete-user-query
                                             {:user user}))
                      :on-success [::delete-user-success]}}))

(re-frame/reg-event-fx
 ::delete-user-success
 standard-interceptors
 (fn [{:keys [db]} [res]]
   {:dispatch [::remove-user (get-in res [:data :deleteUser])]}))

;; Add a user to the list of users in the application db
(re-frame/reg-event-db
 ::add-user
 standard-interceptors
 (fn [db [user]]
   (update-in db [:staffs] conj user)))

;; Edit a user to the list of users in the application db
(re-frame/reg-event-db
 ::edit-user
 standard-interceptors
 (fn [db [user]]
   (let [user-idx (index-of (map :id (:staffs db)) (:id user))]
     (update-in db [:staffs user-idx] merge user))))

;; Remove a user to the list of users in the application db
(re-frame/reg-event-db
 ::remove-user
 standard-interceptors
 (fn [db [staff]]
   (let [old-staffs (:staffs db)
         new-staffs (into [] (remove #(= (:id %) (:id staff)) old-staffs))]
     (assoc db :staffs new-staffs))))

;; Edit a user to the user profile in the application db
(re-frame/reg-event-db
 ::edit-userinfo
 standard-interceptors
 (fn [db [userinfo]]
   (assoc-in db [:settings :userinfo] userinfo)))
